<template>
  <section class="myProfitz">
    <div class="totalsProfitz">
      <p>PROFITZ ACUMULADO</p>
      <h1>{{ Math.round(card_balance) }} <span>profitz</span></h1>
    </div>

    <div class="tab">
      <button class="tablinks" @click="openOption($event, 'history')">
        Extrato
      </button>
      <!-- <button class="tablinks" @click="openOption($event, 'redeem')">
        Resgatar
      </button> -->
    </div>

    <div
      id="history"
      class="tabcontent"
      v-if="termos != false && historico.length != -1"
    >
      <div v-for="(item, i) in historico" :key="i">
        <div v-if="item.value > 0" class="cards">
          <div class="cards__icon">
            <i class="fas fa-piggy-bank"></i>
          </div>
          <div class="cards__content">
            <h3>
              Você ganhou {{ item.value / 100 }} Profitz pela venda realizada
            </h3>
            <p>{{ item.description }}.</p>
            <span>{{
              moment(item.updatedAt).format("DD/MM/YYYY HH:mm:ss")
            }}</span>
          </div>
        </div>
        <div v-if="item.value < 0" class="cards">
          <div class="cards__icon">
            <i class="fas fa-arrow-down resgate"></i>
          </div>
          <div class="cards__content">
            <h3>Você resgatou {{ item.value / 100 }} Profitz</h3>
            <p>Você resgatou {{ item.value / 100 }} Profitz.</p>
            <span>{{
              moment(item.updatedAt).format("DD/MM/YYYY HH:mm:ss")
            }}</span>
          </div>
        </div>
      </div>
      <div class="cards__void" v-if="historico.length == 0">
        <p>Você ainda não possui extrato há ser exibido.</p>
      </div>
    </div>
    <div id="redeem" class="tabcontent" v-if="termos != false">
      <div class="cards cards--refrigas">
        <div class="cards__content">
          <h3>Profitz Refrigás</h3>
        </div>
      </div>

      <div class="cards cards--redeem">
        <div class="cards__content">
          <router-link to="/panel/redeem"> Brindes </router-link>
        </div>
      </div>
    </div>
    <div class="terms" v-if="termos == false">
      <p>
        Para visualizar o extrato e resgatar seus <strong>Profitz</strong>, é
        necessário estar participando da Campanha Bombou Lucrou.
      </p>
      <div class="terms__accept">
        <input
          type="checkbox"
          name="aceiteTermos"
          id="aceiteTermos"
          @click="verificarCheckbox"
        />
        <label class="label" for="">
          Quero participar da Campanha Bombou Lucrou. Li e aceito os
          <a
            href="https://leverosintegra.com.br/download/manuais/Bombou-Lucrou/Termos-e-Condicoes-da-Campanha.pdf"
            target="_blank"
            rel="noopener"
            >Termos e Condições da Campanha</a
          ></label
        >
      </div>
      <button id="aceiteCampanha" @click="aceitarCampanha">Aceitar</button>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      card_balance: 0,
      historico: [],
      termos: false,
      aceite: false,
    };
  },
  methods: {
    openOption(e, option) {
      var i, tabcontent, tablinks;

      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(
          " tablinks--active",
          ""
        );
      }

      document.getElementById(option).style.display = "block";
      e.currentTarget.className += " tablinks--active";
    },

    verificarCheckbox() {
      let checkbox = document.getElementById("aceiteTermos").checked;

      if (checkbox == true) {
        this.aceite = true;
        document.getElementById("aceiteCampanha").disabled = false;
      } else {
        this.aceite = false;
        document.getElementById("aceiteCampanha").disabled = true;
      }
    },

    aceitarCampanha() {
      let dados = JSON.parse(localStorage.getItem("login"));
      if (this.aceite == true) {
        axios
          .put(
            `https://pricing-api.leverosservicos.com.br/campanhas/aceite/${dados.cpfCnj}/${dados.email}`
          )
          .then((res) => {
            console.log(res)
            setTimeout(() => {
              window.location.href = "/panel/profitz/MyProfitz";
            }, 2000);
          });
      }
    },
  },
  beforeMount() {
    let dados = JSON.parse(localStorage.getItem("login"));
    //Consulta Profitz
    axios
      .get(`https://leverosintegra.dev.br/api/bcdigital/registerOld/${dados.cpfCnj}`)
      .then((res) => {
        if (res.data == "") {
          this.card_balance = 0;
        } else {
          this.card_balance = res.data.card_balance / 100;
        }
      });

    // Extrato
    axios
      .get(`https://leverosintegra.dev.br/api/bcdigital/extractCintra/${dados.cpfCnj}`)
      .then((res) => (this.historico = res.data));

    // Retornar se aceitou ou não os termos
    axios
      .get(`https://pricing-api.leverosservicos.com.br/campanhas/aceite/${dados.cpfCnj}`)
      .then((res) => {
        if (res.data != null) {
          this.termos = res.data.aceite;
        } else {
          this.termos = false;
        }
      });

    this.aceitarCampanha();
  },

  mounted() {
    document.getElementById("aceiteCampanha").disabled = true;
  },
};
</script>

<style lang="scss" scoped>
#history {
  display: block;
}
.myProfitz {
  max-width: 100%;
  margin: 0 auto;
  padding-top: 50px;

  @media (min-width: 1025px) {
    max-width: 40%;
  }

  @media (min-width: 441px) and (max-width: 1024px) {
    max-width: 60%;
  }

  .totalsProfitz {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      font-size: 0.95rem;
    }

    h1 {
      padding: 12px 0 40px 0;
      span {
        font-weight: 500;
      }
    }
  }

  .terms {
    padding-top: 30px;

    p {
      padding-bottom: 20px;
      font: 500 0.95rem/1.7 "Soleto", sans-serif;
    }

    &__accept {
      label {
        font-size: 0.95rem;

        a {
          color: var(--standardGreen);
        }
      }
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
      border-radius: 5px;
      text-transform: uppercase;
      padding: 7px 15px;
      margin-top: 22px;
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
        0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
      font-size: 0.95rem;
      letter-spacing: 0.0892857143rem;
      outline: none;

      &:disabled {
        background: #005a6479;
      }
    }
  }

  .tab {
    display: flex;
    justify-content: space-evenly;
    box-shadow: -1px 7px 9px -6px var(--customGray-200);
    padding: 10px;
  }

  .tablinks {
    outline: none;
    padding: 10px 0;

    &--active {
      border-bottom: 4px solid var(--standardGreen);
      font-weight: bold;
    }
  }

  .tabcontent {
    display: none;
    background: var(--customGray-100);
    margin-top: 20px;
    padding: 20px;
  }

  .cards {
    background: var(--customWhite);
    display: flex;
    padding: 10px;
    margin-top: 10px;

    &--refrigas {
      background: linear-gradient(
        90deg,
        rgba(0, 90, 100, 1) 0%,
        rgba(28, 162, 177, 0.9051995798319328) 31%
      );
      cursor: pointer;
      color: var(--customWhite);
      height: 60px;
    }

    &--redeem {
      background: linear-gradient(
        90deg,
        rgb(49, 184, 184) 0%,
        rgba(81, 202, 202, 0.914) 31%
      );
      cursor: pointer;

      a {
        color: var(--customWhite);
        text-decoration: none;
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }

    &__icon {
      font-size: 2.5rem;
      color: var(--standardGreen);
      border: 1px solid var(--customGray-100);
      padding: 10px;
      display: flex;
      align-items: center;

      i {
        font-size: 3.125rem;
      }
    }

    .resgate {
      color: #ca1c1c;
    }

    &__content {
      padding-left: 10px;
      -webkit-animation: fadeEffect 1.5s;
      animation: fadeEffect 1.5s;

      span {
        font-size: 0.95rem;
        color: var(--customGray-500);
      }

      p {
        font-size: 0.95rem;
        color: var(--customGray-500);
        padding-bottom: 5px;
      }

      h3 {
        font: 500 0.95rem/2.7 "Soleto", sans-serif;
      }
    }

    @-webkit-keyframes fadeEffect {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes fadeEffect {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    &__void {
      p {
        font-size: 0.95rem;
        color: var(--customGray-500);
      }
    }
  }
}
</style>